import React from 'react';

import { Avatar, Stack, Typography } from '@lyearn/ui';
import { UserType } from '@/types/schema';

import { BaseItemProps } from '../../types';

const BaseLearnerItem: React.FC<BaseItemProps<UserType>> = (props) => {
  const { item } = props;

  return (
    <>
      <Avatar size={36} src={item.profilePicture || ''} />
      <Stack className="overflow-hidden" direction="col">
        <Typography className="truncate" color={'text-text-primary'} variant="body-short-02">
          {item.name}
        </Typography>
        <Typography className="mt-2" color={'text-text-secondary'} variant="body-short-03">
          {item.uniqueId}
        </Typography>
      </Stack>
    </>
  );
};

export default BaseLearnerItem;
